import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  Box,
} from '@mui/material';

const TopUpDialog = ({ open, onClose, topUpPackages, onTopUpPurchase, loading }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth data-test-id="topup-dialog">
            <DialogTitle>Purchase Top-up</DialogTitle>
            <DialogContent>
            <List>
                {topUpPackages.map((pkg) => (
                <ListItem key={pkg.id} divider>
                    <ListItemText
                        primary={pkg.name}
                        secondary={
                            <Box>
                                <Typography variant="body2">{pkg.description}</Typography>
                                <Typography variant="body2">{pkg.minutes} minutes</Typography>
                            </Box>
                        }
                        secondaryTypographyProps={{ component: 'div' }}
                    />
                    <ListItemSecondaryAction>
                    <Box sx={{ textAlign: 'right' }}>
                        <Typography variant="h6" color="primary">
                        {pkg.price_eur} EUR
                        </Typography>
                        <Button
                        variant="contained"
                        color="primary"
                        onClick={() => onTopUpPurchase(pkg.id)}
                        disabled={loading}
                        data-test-id={`topup-purchase-btn-${pkg.id}`}
                        >
                        Purchase
                        </Button>
                    </Box>
                    </ListItemSecondaryAction>
                </ListItem>
                ))}
            </List>
            </DialogContent>
            <DialogActions>
            <Button onClick={onClose} data-test-id="topup-cancel">Cancel</Button>
            </DialogActions>
      </Dialog>
    );
}

export default TopUpDialog;
